import { render, staticRenderFns } from "./CandidateJobsWrapper.vue?vue&type=template&id=f377dc4c&scoped=true&"
import script from "./CandidateJobsWrapper.vue?vue&type=script&lang=ts&"
export * from "./CandidateJobsWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f377dc4c",
  null
  
)

export default component.exports